export default __webpack_public_path__ + "static/media/default_image.3d652b80.png";